import { Link } from "react-router-dom";
import { useLocalePath, useT } from "@/i18n/LocaleContext";

export const Wordmark = ({ variant = "light" }) => {
  const { t } = useT();
  const localePath = useLocalePath();
  const isLight = variant === "light";
  const wordColor = isLight ? "text-cream" : "text-navy";
  const subColor = isLight ? "text-cream/70" : "text-navy/60";

  return (
    <Link
      to={localePath("/")}
      data-testid="site-wordmark-link"
      className="inline-flex flex-col items-start leading-none group"
      aria-label={`${t("common.entity")} — Home`}
    >
      <span className="inline-flex items-center gap-2">
        <span
          className={`font-serif ${wordColor} text-[22px] sm:text-[24px] tracking-wordmark font-medium`}
          style={{ letterSpacing: "0.22em" }}
        >
          {t("common.entity_short", "QUANTUM")}
        </span>
        <span className="h-1 w-1 rounded-full bg-gold translate-y-[-2px]" aria-hidden />
      </span>
      <span
        className={`mt-1 font-sans ${subColor} text-[10px] sm:text-[10.5px] font-medium uppercase`}
        style={{ letterSpacing: "0.18em" }}
      >
        {t("common.entity")}
      </span>
    </Link>
  );
};

export default Wordmark;
